module.exports = __webpack_public_path__ + "static/media/barmag1b3.bf00b673.jpg";